import { render, staticRenderFns } from "./pso.vue?vue&type=template&id=5ad8ef4b&"
import script from "./pso.vue?vue&type=script&lang=js&"
export * from "./pso.vue?vue&type=script&lang=js&"
import style0 from "./pso.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports